function PracticeAreasSection() {
  return (
    <section id="practice-areas" className="bg-gray-50 text-deepgreen px-6 py-24">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-aos="fade-up">
          Practice Areas
        </h2>
        <div className="w-24 h-1 bg-gold mx-auto mb-12"></div>
        
        <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-left">
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Family Law</h3>
            <p className="text-gray-600 leading-relaxed">
              Guidance through divorce, child custody, guardianship, and related matters with sensitivity and confidentiality.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Criminal Defense</h3>
            <p className="text-gray-600 leading-relaxed">
              Strong representation for individuals facing criminal charges, from investigation through trial.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Employment Law</h3>
            <p className="text-gray-600 leading-relaxed">
              Advice for both employers and employees on rights, contracts, and workplace disputes.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Estate Planning</h3>
            <p className="text-gray-600 leading-relaxed">
              Support with wills, trusts, succession planning, and asset distribution strategies.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up" data-aos-delay="400">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Property Law</h3>
            <p className="text-gray-600 leading-relaxed">
              Legal services for conveyancing, land ownership, lease agreements, and real estate transactions.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-gold group" data-aos="fade-up" data-aos-delay="500">
            <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-gold transition-colors">Constitutional Law</h3>
            <p className="text-gray-600 leading-relaxed">
              Experienced advocacy in human rights cases and constitutional interpretation before high court and courts of equal status, court of appeal and supreme court
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PracticeAreasSection;
